export default __webpack_public_path__ + "static/media/entrepreneur.0bd96f47.png";